export const dateFormatKey = new Intl.DateTimeFormat("en", {
    month: "numeric",
    day: "numeric",
    timeZone: "UTC",
});

export const dateFormatRich = new Intl.DateTimeFormat("en", {
    month: "long",
    day: "numeric",
    timeZone: "UTC",
});

export const convertChartLabelDate = (date: Date | null, dateTimeFormat: Intl.DateTimeFormat): string =>
    date ? dateTimeFormat.format(date) : "-";
